import { PIAPI } from '@core/base';
import { CreateTaskRequest, TaskResponse } from '@core/types';
import { AIHugConfig, AIHugVideoParams, AIHugTaskOutput } from './types';

export class AIHugAPI extends PIAPI {
  private config: AIHugConfig;

  constructor(apiKey: string, config: AIHugConfig = {}, baseUrl?: string) {
    super(apiKey, baseUrl);
    this.config = config;
  }

  private validateImageUrl(imageUrl: string) {
    try {
      new URL(imageUrl);
    } catch (error) {
      throw new Error('Invalid image URL format');
    }
  }

  private createAIHugRequest(params: AIHugVideoParams): CreateTaskRequest {
    // Validate image URL
    this.validateImageUrl(params.image_url);

    const request: CreateTaskRequest = {
      model: 'Qubico/hug-video',
      task_type: 'image_to_video',
      input: {
        image_url: params.image_url,
        duration: params.duration?.toString() ?? '5',
      },
      config: {
        service_mode: 'public',
      },
    };

    if (this.config.webhookUrl && this.config.webhookSecret) {
      request.config = {
        ...request.config,
        webhook_config: {
          endpoint: this.config.webhookUrl,
          secret: this.config.webhookSecret,
        },
      };
    }

    return request;
  }

  async generateVideo(
    params: AIHugVideoParams
  ): Promise<TaskResponse<AIHugTaskOutput>> {
    const request = this.createAIHugRequest(params);
    return this.createTask<AIHugTaskOutput>(request);
  }

  async getVideoTask(taskId: string): Promise<TaskResponse<AIHugTaskOutput>> {
    return this.getTask<AIHugTaskOutput>(taskId);
  }
} 